<template>
  <b-card style="padding:40px;">
    <h5 v-if="form.access_lvl == 3"><b>HOME DEALER</b></h5>
    <h5 v-if="form.access_lvl == 4"><b>AGENT</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Date Of Birth</label>
          <b-form-input
            v-model="form.dob"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-company`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-company`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Role</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label v-if="form.access_lvl == 3" :for="`input-role`"
            >Stokist Name</label
          >

          <label v-if="form.access_lvl == 4" :for="`input-role`"
            >Home Dealer Name</label
          >
          <b-form-input
            v-model="form.stokist"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address</label>
          <b-form-input
            v-model="form.add1"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add2"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add3"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">State</label>
          <b-form-input
            v-model="form.state"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">City</label>
          <b-form-input
            v-model="form.city"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Postcode</label>
          <b-form-input
            v-model="form.postcode"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Phone Number</label>
          <b-form-input
            v-model="form.phone_no"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Email</label>
          <b-form-input
            v-model="form.email"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-tabs v-model="tabIndex" content-class="mt-3">
      <b-tab title="Stockout" active>
        <TableStockout :fields="fields.stockout" :items="items" />
      </b-tab>

      <b-tab title="Agent" v-if="form.myLevel == 2 && form.access_lvl != 4">
        <TableSubDealerInside :fields="fields.fields" :items="items_sd" />
      </b-tab>

      <b-tab title="Purchase Order" v-if="form.access_lvl == 2">
        <TablePO :fields="fields.po" :items="items_po" />
      </b-tab>

      <b-tab title="Purchase Order" v-if="form.access_lvl == 2">
        <TablePO :fields="fields.po" :items="items_po" />
      </b-tab>

      <b-tab title="Delivery Order" v-if="form.access_lvl == 2">
        <TableDeliveryOrderIndex :fields="fields.do" :items="items_do" />
      </b-tab>

      <!-- <b-tab title="Monthly Forecast"> </b-tab> -->
    </b-tabs>

    <b-row>
      <b-col align="right">
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
// import TableSubDealerView from "@/table/user/subDealer/TableSubDealerView";
import TableStockout from "@/table/user/subDealer/TableStockout";
import TableDeliveryOrderIndex from "@/table/user/deliveryOrder/TableDeliveryOrderIndex";
import TablePO from "@/table/user/subDealer/TablePO";
import TableSubDealerInside from "@/table/user/subDealer/TableSubDealerInside";

export default {
  data() {
    return {
      items: [],
      items_po: [],
      items_do: [],
      items_sd: [],

      form: {
        name: "",
        dob: "",
        access_lvl: "",
        company: "",
        role: "",
        stokist: "",
        chiller: "",
        add1: "",
        add2: "",
        add3: "",
        state: "",
        city: "",
        postcode: "",
        phone_no: "",
        email: "",
        myLevel: ""
      },

      // Tab Index
      tabIndex: 0,

      fields: {
        stockout: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Outlet Name",
            key: "name",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Outlet Category",
            key: "category",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Product Type",
            key: "pro_cat",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Date",
            key: "date",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],

        fields: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Role",
            key: "role",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],

        po: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],
        do: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],

        mf: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Month",
            key: "month",
            sortable: true
          },
          {
            label: "Status",
            key: "status",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    this.form.myLevel = this.$store.getters.getAccessLevel;
    this.showUser();
    this.getStockout();
    this.getPO();
    this.getDO();
    this.getAgent();
  },
  methods: {
    showUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.access_lvl = res.data.data.access_lvl;
            this.form.dob = res.data.data.dob;
            this.form.company = res.data.data.company;
            this.form.role = res.data.data.role_details.desc;
            this.form.chiller = res.data.data.chiller;
            this.form.add1 = res.data.data.add1;
            this.form.add2 = res.data.data.add2;
            this.form.add3 = res.data.data.add3;
            this.form.state = res.data.data.state_details.desc;
            this.form.city = res.data.data.city;
            this.form.postcode = res.data.data.postcode;
            this.form.email = res.data.data.email;
            this.form.phone_no = res.data.data.phone_no;
            this.form.stokist = res.data.data.downline.userdetails.name;
          }
        });
    },

    getAgent() {
      this.items_sd = [];
      this.$store
        .dispatch("getIndividualDownline", this.$route.query.id)
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            let no = 0;
            res.data.data.forEach(element => {
              no = no + 1;
              this.items_sd.push({
                no: no,
                name: element.name,
                role: element.access_lvl,
                id: element.user_id
              });
            });
          }
        });
    },

    getStockout() {
      this.$store
        .dispatch("getStockout", {
          category: 1,
          user_id: this.$route.query.id
        })
        .then(res => {
          let no = 0;
          res.data.data.forEach(element => {
            no = no + 1;
            let outletCat, type;
            if (element.outlet !== null) {
              outletCat = element.outlet.name;
            }

            type = element.type === 1 ? "UHT" : "Pasteurized";
            this.items.push({
              no: no,
              name: element.outlet_name,
              category: outletCat,
              pro_cat: type,
              date: element.date,
              id: element.stock_id,
              type: element.type
            });
          });
          // this.totalRows = this.items.length;
        });
    },

    getPO() {
      this.$store
        .dispatch("getPO", {
          category: 2,
          user_id: this.$route.query.id
        })
        .then(res => {
          res.data.data.forEach(element => {
            this.items_po.push({
              date: element.date,
              id: element.stock_id
            });
          });
          // this.totalRows = this.items.length;
        });
    },
    getDO() {
      this.$store
        .dispatch("getDO", {
          category: 4,
          user_id: this.$route.query.id
        })
        .then(res => {
          res.data.data.forEach(element => {
            this.items_do.push({
              date: element.date,
              id: element.delivery_id
            });
          });
          // this.totalRows = this.items.length;
        });
    },

    onClickBack() {
      this.$router.go(-1);
    }
  },
  components: {
    // TableSubDealerView
    TableStockout,
    TableDeliveryOrderIndex,
    TablePO,
    TableSubDealerInside
  }
};
</script>
<style lang="css" scoped></style>
